import { Country as LibCountry, State as LibState } from 'country-state-city';

export const Country = {
  getAllCountries: () =>
    LibCountry.getAllCountries().map((country) => ({
      name: country.name,
      code: country.isoCode,
    })),
  getCountryStates: (countryCode?: string) => {
    return LibState.getStatesOfCountry(countryCode).map((state) => ({
      name: state.name,
      code: state.isoCode,
    }));
  },
};
